
import { useState, useEffect } from 'react'
import Header from "../Header/Header";
import { Layout } from "../Layout/Layout";
import { AddCompetency } from "./Modal/AddCompetency";
import { CompetencyList } from "../Common/CompetencyList"
import Swal from 'sweetalert2'
import axios from 'axios'
import { AllCompetencyList } from '../Common/AllCompetencyList';
import { IconButton, Tooltip } from '@mui/material';
import { Add } from '@mui/icons-material';

export default function CompetencyLibraries() {
    const [show, setShow] = useState(false);
    const [popupType, setPopupType] = useState("Add");
    const [editId, setEditId] = useState(0);
    const [competencies, setCompetencies] = useState([]);
    
    useEffect(() => {
        getList();
    }, []);

    const getList = async () => {
        let apiUrl = "/api/competencies";

        await axios.get(apiUrl).then(function (response) {
            let result = response.data;
            if (result.success) {
                setCompetencies(result.data);
            } else {
                // Handle error or set isError state if needed.
            }
        });
    };

    const [accordion, setAccordion] = useState({});
    const [isChange, setIsChange] = useState(false);

    const handleAdd = (teamId) => {
        setEditId(0);
        setPopupType('Add');
        setShow(true);
    }

    const handleAccordionChange = (key) => {
        if(accordion && accordion[key]){
            accordion[key] = !accordion[key]
        }
        else{
            accordion[key] = true
        }
        setIsChange((prev) => !prev);
        // Get the accordion button element
        const accordionButton = document.querySelector(`[data-key="${key}"]`);
        // Toggle the active class on the accordion button
        accordionButton.classList.toggle('active');
      }
    return(
        <Layout>
            <Header pageTitle={'Competencies'} />
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="">
                    <div className="card-header d-flex justify-content-between align-items-center">                      
                        <h3 className="fw-bold mb-0">Competency Libraries</h3>
                        <button type="button" onClick={() => handleAdd()} className="btn btn-primary">
                            <span className="tf-icons bx bx-plus"></span>&nbsp; Add Competency
                        </button>
                    </div>

                    <div className="container-xxl flex-grow-1 container-p-y">
                        <div className="row">
                            <div className="col-md mb-4 mb-md-0">
                                <AllCompetencyList competencies={competencies} getList={getList}/>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* {show && (
                <AddCompetency
                    type={popupType}
                    show={show}
                    setShow={setShow}
                    getList={getList}
                    editId={editId}
                    setEditId={setEditId}
                />
            )} */}
            <AddCompetency type={popupType} show={show} setShow={setShow} getList={getList} editId={editId} setEditId={setEditId} />
        </Layout>
    )
}